import React, { useState, useEffect } from "react";
import Row from "@tw/style-guide/lib/components/grid/row";
import Column from "@tw/style-guide/lib/components/grid/column";
import Icon from "@tw/style-guide/lib/components/icon/icon";
import styles from "./footer.scss";
import { useSelector } from "react-redux";
import ResponsiveImg from "@tw/shared-ui-components/lib/components/responsiveImg/responsiveImg";
import { useQueryParams } from "@tw/shared-ui-components/lib/hooks/useQueryParams";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';
const footer = (props) => {
  const queryParams = useQueryParams();
  const footer = useSelector((state) => state.footerState);
  const [UTM_PATAMS_1, setUTM_PATAMS_1] = useState('')
  const [UTM_PATAMS_2, setUTM_PATAMS_2] = useState('')
  useEffect(() => {
    setUTM_PATAMS_1(getQueryUTMString("&"))
    setUTM_PATAMS_2(getQueryUTMString("?"))
  }, [queryParams])
  if (!footer) return null;
  return (
    <footer className={styles.footer_wrapper}>
      <div className={styles.footer_cards_wrapper}>
        {footer && footer.topMenus && (
          <Row>
            {footer.topMenus.map((menu, i) => (
              <Column
                colCountMd={4}
                colCountLg={4}
                key={i}
                className={styles["col-class"]}
              >
                <div
                  className={styles.footer_card}
                  id={
                    i === footer.topMenus.length - 1 && styles.last_child_cards
                  }
                >
                  <img src={menu.icon} />
                  <div className={styles.text_wrapper}>
                    <div className={styles.heading}>
                      <a
                        href={
                          menu.link && menu.link.href.includes("?") ?
                            `${menu.link.href}${UTM_PATAMS_1}` :
                            `${menu.link.href}${UTM_PATAMS_2}`
                        }
                        title={menu.link?.title}
                        target={menu.link?.tabConfig === "new" ? "_blank" : ""}
                        rel="noreferrer"
                      >
                        {menu.title}
                      </a>
                    </div>
                    <div className={styles.sub_text}>{menu.text1}</div>
                    <div className={styles.sub_text}>{menu.text2}</div>
                    <div className={styles.readme_div}>
                      <a
                        href={
                          menu.link && menu.link.href.includes("?") ?
                            `${menu.link.href}${UTM_PATAMS_1}` :
                            `${menu.link.href}${UTM_PATAMS_2}`
                        }
                        title={menu.link?.title}
                        target={menu.link?.tabConfig === "new" ? "_blank" : ""}
                        rel="noreferrer"
                      >
                        <div className={styles.text_bold}>
                          {menu.link && menu.link.title}
                        </div>
                        <div className={styles.black_arrow}>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.63386 19.75C8.75197 19.75 8.85827 19.7149 8.95276 19.6448L16.3583 12.2805C16.4528 12.2104 16.5 12.1169 16.5 12C16.5 11.8831 16.4528 11.7896 16.3583 11.7195L8.95276 4.3552C8.85827 4.28507 8.75197 4.25 8.63386 4.25C8.51575 4.25 8.42126 4.28507 8.35039 4.3552L7.64173 5.05656C7.54724 5.1267 7.5 5.22021 7.5 5.3371C7.5 5.454 7.54724 5.5592 7.64173 5.65271L14.0551 12L7.64173 18.3473C7.54724 18.4408 7.5 18.546 7.5 18.6629C7.5 18.7798 7.54724 18.8733 7.64173 18.9434L8.35039 19.6448C8.42126 19.7149 8.51575 19.75 8.63386 19.75Z"
                              fill="#2C2C2C"
                            />
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </Column>
            ))}
          </Row>
        )}
      </div>
      {/* Footer Cards */}

      {/* Footer Listing Starts */}

      <div className={styles.footer_listing}>
        {footer && footer.navigations && (
          <Row
            classes={{ root: styles["grid-row"] }}
            className={styles["grid-row"]}
          >
            {footer.navigations.map((menu, i) => (
              <Column
                colCountSm={12}
                colCountMd={6}
                colCountLg={6}
                key={i}
                className={styles["grid-column"]}
              >
                <div className={styles.item}>
                  <a
                    href={
                      menu.link && menu.link.href.includes("?") ?
                        `${menu.link.href}${UTM_PATAMS_1}` :
                        `${menu.link.href}${UTM_PATAMS_2}`
                    }
                    target={
                      menu.link && menu.link.tabConfig === "new" ? "_blank" : ""
                    }
                  >
                    <div className={styles.text}>{menu.title}</div>
                  </a>
                  <a
                    href={
                      menu.link && menu.link.href.includes("?") ?
                        `${menu.link.href}${UTM_PATAMS_1}` :
                        `${menu.link.href}${UTM_PATAMS_2}`
                    }
                    target={
                      menu.link && menu.link.tabConfig === "new" ? "_blank" : ""
                    }
                    className={styles.icon_wrapper}
                  >
                    <Icon name="right_arrow_white" />
                  </a>
                </div>
              </Column>
            ))}
          </Row>
        )}

        {footer && footer.socialCommunity && (
          <div className={styles.social_community}>
            {footer.socialCommunity.title && (
              <div className={styles.title}>{footer.socialCommunity.title}</div>
            )}
            {footer.socialCommunity.sites && (
              <div className={styles.sites}>
                {footer.socialCommunity.sites.map((site, index) => (
                  <div className={styles["site"]} key={index}>
                    <a
                      rel="noreferrer"
                      target={site.link?.tabConfig === "new" ? "_blank" : ""}
                      href={
                        site.link && site.link.href.includes("?") ?
                          `${site.link.href}${UTM_PATAMS_1}` :
                          `${site.link.href}${UTM_PATAMS_2}`
                      }
                      title={site.link?.title}
                    >
                      {/* <img src={site.image} /> */}
                      <ResponsiveImg src={site.image} />
                    </a>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Footer Listing Ends */}

      {/* Copyright Section Starts */}
      {footer && footer.bottom && (
        <div className={styles.copyright_section_wrapper}>
          <div className={styles.copyright_section}>
            <div className={styles.copyright_text}>
              {footer.bottom.copyrightText}
            </div>
            <div className={styles.listing}>
              {footer.bottom.links &&
                footer.bottom.links.map((link, i) => (
                  <a
                    href={
                      link.link && link.link.href.includes("?") ?
                        `${link.link.href}${UTM_PATAMS_1}` :
                        `${link.link.href}${UTM_PATAMS_2}`
                    }
                    target={
                      link.link && link.link.tabConfig === "new" ? "_blank" : ""
                    }
                    className={styles.item}
                    key={i}
                  >
                    {link.title}
                  </a>
                ))}
            </div>
          </div>
        </div>
      )}
      {/* Copyright Section Ends */}
    </footer>
  );
};

export default footer;
